// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"26213a28","150":"f9541e23","182":"59e4c301","311":"fa933f2f","312":"956cf980","332":"4bbe007f","705":"b5d435b7"}[chunkId] + ".chunk.js";
};